import { jsx as _jsx } from "react/jsx-runtime";
import { ExportTabs } from '@src/components/Admin/ExportTabs';
import { ImportTabs } from '@src/components/Admin/ImportTabs';
import { ReportTabs } from '@src/components/Admin/ReportTabs';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useParams } from 'react-router-dom';
import { Servers } from '../Servers';
export const IntegrationTabs = () => {
    const clientId = useClientIdParam() || 0;
    const { tab = 'servers' } = useParams();
    if (tab === 'imports') {
        return _jsx(ImportTabs, { clientId: clientId });
    }
    if (tab === 'exports') {
        return _jsx(ExportTabs, { clientId: clientId });
    }
    if (tab === 'report-templates') {
        return _jsx(ReportTabs, { clientId: clientId });
    }
    return _jsx(Servers, { clientId: clientId });
};
